import React from "react";
import PropTypes from "prop-types";
import {Table, Pagination, Divider} from "semantic-ui-react";
import {PageSizeSelect} from "./paging/page-size-select";
import DataTable from "./data-table";
import DataProvider from "./data-providers/data-provider";
import {Observable, Subject, merge} from "rxjs";
import ExportDataProvider from "./data-providers/export-data-provider";
import {BasicFilter} from "./filters/basic-filter";
import {NoFilter} from "./filters/no-filter";
import moment from "moment";


export default class FilterableDatatable extends React.Component {
    constructor(props) {
        super(props);
        this.localRefreshTrigger = new Subject();
        this.onRefreshTrigger = this.generateRefreshTrigger();



        this.state = {
            totalCount: this.props.data ? this.props.data.length : 0,
            hasAppliedInitialFilter: false,
            isLoading: false,
            lastOverrides: {
                statusOverride: props.statusOverride,
                supplyOverride: props.supplyOverride,
                meterTypeOverride: props.meterTypeOverride,
                supplierOverride: props.supplierOverride,
                queryTypeOverride : props.queryTypeOverride
            },
            pageSettings: {
                pageNo: this.props.startingPage || 1,
                pageSize: this.props.startingLimit || 10
            },
            filterSettings: {
                filter: "",
                fromDate: null,
                toDate: null,
                advancedFiltersSelected: {}
            },
            initialLoadorOverrideChange: true, 

        }
    }

    componentDidMount = () => {
       // this.getRecentFilter();
       
        
        
    }
    

    componentDidUpdate(prevProps){
        const { hasAppliedInitialFilter } = this.state;
        const prevInitialDate = prevProps.filterComponentProps?.initialDate;
        const currentInitialDate = this.props.filterComponentProps?.initialDate;
    
        if (!hasAppliedInitialFilter && prevInitialDate !== currentInitialDate && currentInitialDate) {
            this.onFilterChange({
                fromDate: currentInitialDate,
                toDate: moment(currentInitialDate).endOf('month').format("YYYY-MM-DD"),
            });
            this.setState({ hasAppliedInitialFilter: true }, (() => {
                this.onFilterChange({
                    fromDate: currentInitialDate,
                    toDate: moment(currentInitialDate).endOf('month').format("YYYY-MM-DD"),
                })

                this.requestRefresh()
            }))
              
            

        }

    }

    getRecentFilter () {
        
         if(this.props.storeName !== "" && this.props.clearStore === false)
         {
             this.setState(prevState => {
                 return {
                  ...prevState,
                   filterSettings: {
                    ...prevState,
                     filter : ((localStorage.getItem(this.props.storeName) === null || localStorage.getItem(this.props.storeName) === 'null') ? '' : localStorage.getItem(this.props.storeName))
                   }
                 };
               });
               this.requestRefresh()

         }else if (this.props.storeName !== "" && this.props.clearStore)
         {
            localStorage.removeItem(this.props.storeName)
            this.requestRefresh()

         } 
    }



    generateRefreshTrigger() {
        const dependents = [this.localRefreshTrigger];
        if (this.props.refreshDataTrigger) {
            dependents.push(this.props.refreshDataTrigger);
        }
        return merge(...dependents);
    }

    get totalPages() {
        return Math.ceil(this.state.totalCount / this.state.pageSettings.pageSize);
    }

    onChangeLimit = (event, data) => {

        
        const pageSize = data.value;

        if(pageSize === 'All')
        {
            if (pageSize !== this.state.totalCount) {
                const pageSettings = {pageNo: this.state.pageSettings.pageNo, pageSize:  this.state.totalCount};
                this.setState({pageSettings}, this.requestRefresh);
            }
        }
        else if (pageSize !== this.state.pageSettings.pageSize) {
            const pageSettings = {pageNo: this.state.pageSettings.pageNo, pageSize: pageSize};
            this.setState({pageSettings}, this.requestRefresh);
        }
    };

    onChangePage = (event, data) => {
        const activePage = data.activePage;
        if (activePage !== this.state.pageSettings.pageNo) {
            const pageSettings = {pageNo: activePage, pageSize: this.state.pageSettings.pageSize};
            this.setState({pageSettings}, this.requestRefresh);
        }
    };

    onFilterChange = (filterSettings) => {
      


        if(this.props.storeName !== "")
        {
            localStorage.setItem(this.props.storeName, filterSettings.filter)
        }
        this.setState({pageSettings: {
            pageNo: 1,
            pageSize: this.state.pageSettings.pageSize
        }})

        this.setState(prevState => {
            return {
             ...prevState,
              filterSettings: {
                    ...prevState.filterSettings,
                    filter : [filterSettings.filter],
                    fromDate : filterSettings.fromDate,
                    toDate : filterSettings.toDate,
                    multiFromDate : filterSettings.multiFromDate,
                    multiToDate : filterSettings.multiToDate,
                }
              }
           }, () => {
            this.requestRefresh()
            
        });

    };

  

    onAdvancedFilterChange = (filters) => {
    
        this.setState(prevState => {
            // Copy the previous filter settings to maintain other state elements.
            const { filterSettings } = prevState;
            const updatedAdvancedFilters = { ...filterSettings.advancedFiltersSelected };
            if (filters && typeof filters.name === 'string' && filters.name.length >= 0 && filters.value) {
            // Check if the incoming filter values array is not empty.
            if (filters.value.length > 0) {
                // Update or set the filter values.

                updatedAdvancedFilters[filters.name] = filters.value;
            } else {

              
                if(filters.name === "utility" && this.contextData.updateSupplyOverride)
                {
                    this.contextData.updateSupplyOverride("")
                }

                // If the filter values array is empty, delete the filter from state.
                delete updatedAdvancedFilters[filters.name];
            }
        } else {
            // Log an error or handle the case where filters are not properly formatted
            //console.error('Invalid filter format:', filters);

            

            if (filters && typeof filters.name === 'string' && filters.name.length > 0) {
                delete updatedAdvancedFilters[filters.name];
            }else
            {
            
            return {}; // Return current state unchanged if the filter format is invalid
            }
        }
    

            return {
                ...prevState,
                filterSettings: {
                    ...filterSettings,
                    advancedFiltersSelected: updatedAdvancedFilters
                },
                pageSettings: {
                    ...prevState.pageSettings,
                    pageNo: 1 // Reset to the first page on filter change
                }
            };
        }, () => {
            this.requestRefresh(); // Refresh the data after state update
        });
    };
    

    getDataProviderContext = () => {
        const localContext = {
            pageSettings: this.state.pageSettings,
            filterSettings: this.state.filterSettings
        };

        if (!this.props.additionalProviderContext) {
            return localContext;
        }

        return {...localContext, ...this.props.additionalProviderContext()}
    };

    updateTotalCount = (data) => {

        this.setState({totalCount: data.totalCount, isLoading: false, advancedFiltersItems : data.advancedFilters});

        if (this.props.onTableRefreshed) {
            this.props.onTableRefreshed(data);
        }
    };

    requestRefresh = () => {


        //console.log("this.requestRefresh")
        const { statusOverride, supplyOverride, meterTypeOverride, supplierOverride,queryTypeOverride } = this.props;
        const { lastOverrides } = this.state;


        const hasOverridesChanged = (
            lastOverrides.statusOverride !== statusOverride ||
            lastOverrides.supplyOverride !== supplyOverride ||
            lastOverrides.queryTypeOverride !== queryTypeOverride ||

            lastOverrides.meterTypeOverride !== meterTypeOverride ||
            lastOverrides.supplierOverride !== supplierOverride
        );



        if(hasOverridesChanged) 
        {
          this.setState({  
            isLoading: true,
            lastOverrides: {
                                statusOverride,
                                supplyOverride,
                                meterTypeOverride,
                                supplierOverride,
                                queryTypeOverride
                            },
                pageSettings: {
                pageNo: 1,
                pageSize: this.state.pageSettings.pageSize,
                 }
                
                
                            }, () => {
                this.localRefreshTrigger.next();
            });
        }else
        {

            this.setState({isLoading: true});
            this.localRefreshTrigger.next();
        }
       
    };


    render() {
        
       
        
        const Filter = this.props.filterComponent || BasicFilter;
        const filterComponentProps = {
            ...this.props.filterComponentProps, // Spread any props provided specifically for the filter component
            // You can still pass common props that every filter component might need
            onSubmitFilter: this.onFilterChange,
            onAdvancedFilterChange: this.onAdvancedFilterChange,
            disabled: this.state.isLoading,
            totalCount: this.state.totalCount,
            // Add other common props here

            filter : this.state.filterSettings.filter,
          

            fromDate : this.state.filterSettings.fromDate,
            toDate : this.state.filterSettings.toDate,
            advancedFilters : this.state.advancedFiltersItems,
            fromDateLabel : this.props.fromDateLabel,
            toDateLabel: this.props.toDateLabel,
            multiFromDateLabel : this.props.multiFromDateLabel,
            multiToDateLabel : this.props.multiToDateLabel,
            statusOverride : this.props.statusOverride,
            supplyOverride : this.props.supplyOverride,
            supplierOverride : this.props.supplierOverride,
            initialDate : this.props.initialDate,
            meterTypeOverride: this.props.meterTypeOverride, 
            queryTypeOverride : this.props.queryTypeOverride

            

        };

        return (
            <div className="filterable-table">
                {Filter !== NoFilter &&
               <React.Fragment>
                {React.createElement(Filter, filterComponentProps)}
                <Divider />
            </React.Fragment>
            }
                
                <DataTable dataProvider={this.props.dataProvider} canExport={this.props.canExport}
                           name={this.props.name} defaultSort={this.props.defaultSort} 
                           headerComponent={this.props.headerComponent} rowComponent={this.props.rowComponent}
                           onTableRefreshed={this.updateTotalCount} refreshDataTrigger={this.onRefreshTrigger}
                           additionalProviderContext={this.getDataProviderContext}
                           exportDataProvider={this.props.exportDataProvider}
                           contextData={this.props.contextData}>
                    <DataTable.Header>
                        <React.Fragment>
                            <PageSizeSelect
                                limit={this.state.pageSettings.pageSize}
                                onChangeLimit={this.onChangeLimit}/>
                            Total count: {this.state.totalCount}.
                        </React.Fragment>
                    </DataTable.Header>
                    <DataTable.Footer>
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan="12">
                                    <Pagination
                                        totalPages={this.totalPages}
                                        activePage={this.state.pageSettings.pageNo}
                                        onPageChange={this.onChangePage}/>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </DataTable.Footer>
                </DataTable>
            </div>
        );
    }
};

FilterableDatatable.propTypes = {
    dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
    headerComponent: PropTypes.elementType.isRequired,
    rowComponent: PropTypes.elementType.isRequired,
    refreshDataTrigger: PropTypes.instanceOf(Observable),
    exportDataProvider: PropTypes.instanceOf(ExportDataProvider),
    onTableRefreshed: PropTypes.func,
    defaultSort: PropTypes.string,
    additionalProviderContext: PropTypes.func,
    name: PropTypes.string,
    storeName: PropTypes.string,
    clearStore: PropTypes.bool,
    advancedFilters : PropTypes.any,
    canExport: PropTypes.bool,
    startingPage: PropTypes.number,
    startingLimit: PropTypes.string,
    filterComponent: PropTypes.elementType,
    filterComponentProps: PropTypes.object, 
    contextData: PropTypes.any,
    statusOverride: PropTypes.string,
    supplyOverride: PropTypes.string,
    supplierOverride : PropTypes.string,
    initialDate: PropTypes.string,
    meterTypeOverride : PropTypes.string,
    queryTypeOverride : PropTypes.string

};
